/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable max-len */
import { EventsHero } from '../blocks/EventsHero';
import ProductsGallery from '../blocks/ProductsGallery';
import { AboutForm } from '../forms/AboutForm';
import { InputType } from '../../types';
import { CTATileCarousel } from '../blocks/CTATileCarousel';
import LogoCardGrid from '../blocks/LogoCardGrid';
import { HalfImgHero } from '../blocks';
import MeetTheTeam from '../blocks/MeetTheTeam';
import { ModalForm } from '../forms/ModalForm';
import { useState } from 'react';

export const CES2026Page = () => {
  // State for show/hide forms and setting their associated fields
  const [showFormModal, setShowFormModal] = useState(false);
  const [currentFormConfig, setCurrentFormConfig] = useState(null);

  // Form configurations
  const formConfigs = {
    meetWithAdvertising: {
      heading: '<h3>Meet with<br/><strong>Xumo Advertising</strong></h3>',
      successMessage: 'Thank you for contacting us! Our team has received your inquiry and will connect with you after reviewing your submission.',
      source: 'meet-the-team',
    },
    requestProgrammingDetails: {
      heading: '<h3>Request details for<br/><strong>Lionsgate + Xumo</strong></h3>',
      successMessage: 'Thank you for contacting us! Our team has received your inquiry and will connect with you after reviewing your submission.',
      source: 'panel-lionsgate',
    },
    requestStreamingDetails: {
      heading: '<h3>Request an invite for <br/><strong>Defining Success in FAST with Lionsgate and Xumo</strong></h3>',
      successMessage: 'Thank you for contacting us! Our team has received your inquiry and will connect with you after reviewing your submission.',
      source: 'panel-lionsgate',
    },
    cocktailReception: {
      heading: '<h3>Request an invite for<br/><strong>CES 2025 Xumo Cocktail Reception</strong></h3>',
      successMessage: 'Thank you for contacting us! Our team has received your inquiry and will connect with you after reviewing your submission.',
      source: 'cocktail-party',
    },
  };

  // Shared form fields for all forms
  const formFields = [
    { type: InputType.Name, name: 'first_name', placeholder: 'First name' },
    { type: InputType.Name, name: 'last_name', placeholder: 'Last name' },
    { type: InputType.Email, name: 'email', placeholder: 'Email' },
    { type: InputType.Name, name: 'company', placeholder: 'Company' },
    { type: InputType.Textarea, name: 'message', placeholder: 'Message', width: 'full' },

    // Hidden field for source tracking
    // { type: InputType.Hidden, name: 'source', value: currentFormConfig?.source },
  ];

  // Helper to set correct form config
  const openForm = (configKey: string) => {
    setCurrentFormConfig(formConfigs[configKey]);
    setShowFormModal(true);
  };

  return (
    <>
      <EventsHero
        bgColor="xumoDarkPlum"
        textColor="white"
        eyebrow={'<span>Xumo</span> <span>at</span> <strong>CES</strong> <strong>2026</strong>'}
        title={
          '<span>The</span>  <span>future</span>  <span>of</span>  <span>streaming</span> <span>is</span> <span> <strong>coming</strong> <strong>to</strong> <strong>Vegas</strong></span>'
        }
        body={[
          {
            headingAlt: 'January 6–9',
            className: 'type-heading-alt weight-500',
          },
          {
            bodyBase: 'Vdara Hotel and Spa<br/> Las Vegas, NV',
            className: 'type-subheading-xs mt-12',
          },
        ]}
        imageSrc="/static/images/refresh/2025/ces/hero.webp"
      />
      <LogoCardGrid
        stackedContent={[
          {
            heading: 'All in on streaming',
            className: 'text-white mb-0 md:mb-8',
          },
          {
            bodyBase: 'Xumo is shaping the evolution of streaming — these are the teams making it all happen.',
            className: 'text-white text-[18px] md:text-[20px]',
          },
        ]}
        logoCards={[
          {
            image: { src: '/static/images/refresh/2025/ces/XUMO_TV_LOGO-FullColorReverse-RGB-1.png', alt: 'Xumo TV' },
            body: 'We’re taking our smart TV platform to the next level with developments made for the way you stream.',
          },
          {
            image: { src: '/static/images/refresh/2025/ces/XUMO_STREAM_BOX_LOGO-Stacked-FullColorRevise-RGB-1.png', alt: 'Xumo Stream Box' },
            body: 'We’re partnering with operators of all sizes to distribute our platform as a modern streaming solution that gets you.',
          },
          {
            image: { src: '/static/images/refresh/2025/ces/XUMO_ENTERPRISE_LOGO-Stacked-FullColorReverse-RGB 2.png', alt: 'Xumo Enterprise' },
            body: 'We’re leading the future of FAST with flexible solutions and tech stacks built to adapt to you.',
          },
          {
            image: { src: '/static/images/refresh/2025/ces/XUMO_PLAY_LOGO-Stacked-FullColorReverse-RGB-1.png', alt: 'Xumo Play' },
            body: 'We’re innovating premium, free ad-supported content experiences that revolutionize the way you watch.',
          },
        ]}
      />
      <MeetTheTeam
        bgColor={'xumoDarkPlum'}
        cardTextColor={'white'}
        headerContent={[
          {
            image: {
              src: '/static/images/refresh/2025/ces/1_XUMO_ADVERTISING_LOGO-Horizontal-FullColorReverse-RGB.png',
              alt: 'Xumo Advertising',
              width: 618,
              height: 50,
            },
            className: 'w-[351px] lg:w-[618px] h-auto',
          },
          { title: 'Next-level experiences', className: 'text-white mt-12 mb-12 lg:mt-16 lg:mb-16' },
          {
            bodyBase: 'We’re driving deeper connections with audiences you can’t find anywhere else to create lasting impact for you.',
            className: 'text-white mb-12 lg:mb-24',
          },
          { subheadingLight: 'Meet the team', className: 'text-white mb-2' },
        ]}
        carouselItems={[
          {
            name: 'Ying Wang',
            title: 'General Manager',
          },
          {
            name: 'Eli Zang',
            title: 'VP, Sales',
          },
          {
            name: 'Jerrold Son',
            title: 'VP, Ad Revenue Operations',
          },
          {
            name: 'Mike Gammone',
            title: 'Sr. Director, Sales',
          },
          {
            name: 'Jen Pittenger',
            title: 'Sr. Director, Sales',
          },
          {
            name: "O'Neil Anderson",
            title: 'Sr. Director, Sales',
          },
          {
            name: 'Nicole Malitz',
            title: 'Programmatic Partnerships',
          },
        ]}
        cta={[
          {
            ctaRow: [
              {
                label: 'Request a meeting',
                color: 'xumoAltBerryLight',
                light: true,
                fullalways: true,
                onClick: () => openForm('meetWithAdvertising'),
              },
            ],
          },
        ]}
      />
      <CTATileCarousel
        bgColor="xumoDarkPlum"
        cardBgColor="xumoDarkPlum"
        center={false}
        bgImage="/static/images/refresh/2025/ces/Xumo_Swirl_Transparent_16k.png"
        header={[{ title: 'Xumo’s <strong>CES lineup</strong>', className: 'text-white mb-12 md:mb-24 text-center mx-auto w-[82%] md:w-full' }]}
        tiles={[
          [
            { subheadingSmall: 'Invite only', className: 'text-white mb-2' },
            { headingAlt: 'Money Moves: How the Industry is Influencing Investment', className: 'text-white' },
            { subheadingSmall: 'January 6 | 4&#58;20&ndash;4&#58;45 pm', className: 'text-white mt-4' },
            {
              bodyBase:
                "Streaming and CTV are no longer disruptors—they're defining the future of television. As dollars shift and strategies evolve, agencies are navigating a marketplace transformed by performance-driven TV, the competition for live events, the rapid expansion of FAST, and the growing influence of AI. Hear how leaders are leaning into these shifts in 2026, what they expect from partners, and how they're connecting with streaming audiences in moments that matter.",
              className: 'text-white max-w-[700px] mb-4',
            },
          ],
          [
            { headingAlt: 'Defining Success in FAST with Lionsgate and Xumo', className: 'text-white' },
            { subheadingSmall: 'January 6 | 4&#58;45&ndash;5&#58;00 pm', className: 'text-white mt-4' },
            {
              bodyBase:
                'Explore how Lionsgate is driving growth with a market-leading FAST strategy. Discover insights on programming, monetization and the role of platforms in shaping the next wave of streaming innovation.',
              className: 'text-white max-w-[700px] mb-4',
            },
            {
              ctaRow: [
                {
                  href: 'https://xumopanelsatces2026.rsvpify.com/',
                  label: 'RSVP',
                  color: 'xumoAltBerryLight',
                  light: true,
                  target: '_blank',
                  fullalways: true,
                },
                {
                  href: '',
                  label: 'Request an invite',
                  color: 'xumoAltBerryLight',
                  light: true,
                  fullalways: true,
                  onClick: () => openForm('requestStreamingDetails'),
                },
              ],
            },
          ],
          [
            { subheadingSmall: 'Invite only', className: 'text-white mb-2' },
            { headingAlt: 'The CES Refresh: Touch-Ups by Xumo', className: 'text-white' },
            { subheadingSmall: 'January 7 | 2&#58;00&ndash;6&#58;00 pm', className: 'text-white mt-4' },
            {
              bodyBase: "We're bringing a little calm to the CES chaos with complimentary touch-ups in our suite at the Vdara.",
              className: 'text-white max-w-[700px] mb-4',
            },
          ],

          [
            { subheadingSmall: 'Invite only', className: 'text-white' },
            { headingAlt: 'Brunch at Peacock Alley, Waldorf Astoria', className: 'text-white' },
            { subheadingSmall: 'January 8 | 11&#58;00 am', className: 'text-white' },
            {
              bodyBase: 'Xumo Advertising is hosting an intimate brunch during CES at one of the most elegant settings in Las Vegas.',
              className: 'text-white max-w-[700px]',
            },
          ],
        ]}
      />
      <HalfImgHero
        bgimg="/static/images/refresh/2025/ces/ces-mixer-comp.jpg"
        bgColor="xumoDarkPlum"
        maxHeight1000={true}
        sectionPadding={'pt-6 pb-32 lg:pt-0 lg:pb-0'}
        copyPadding={false}
        imgagePositionTop={true}
        content={[
          {
            subheadingSmall: 'Invite only',
            className: 'text-white -mb-8 weight-300',
          },
          {
            title: 'Mix and <strong>mingle</strong>',
            className: 'text-white',
          },
          {
            bodyBase: 'Join our exclusive, invite-only cocktail party to celebrate CES and network with power players in the streaming industry.',
            className: 'text-white max-w-[650px]',
          },
          {
            subheadingLight: 'January 6 | 5&#58;00 pm',
            className: 'text-white',
          },
          {
            ctaRow: [
              {
                href: 'https://kickoffces2026withxumo.rsvpify.com',
                label: 'RSVP',
                color: 'xumoAltBerryLight',
                light: true,
                target: '_blank',
                fullalways: true,
              },
              {
                href: '',
                label: 'Request an invite',
                color: 'xumoAltBerryLight',
                light: true,
                fullalways: true,
                onClick: () => openForm('cocktailReception'),
              },
            ],
          },
        ]}
        nascarLogo={false}
        bannerActive={false}
      />

      {/* Single modal with dynamic content */}
      {currentFormConfig && (
        <ModalForm
          isDark={true}
          isOpen={showFormModal}
          onClose={() => setShowFormModal(false)}
          heading={currentFormConfig.heading}
          formFields={formFields}
          CTA={{ label: 'Submit' }}
          formAction={{
            submissionEndpoint: `/api/contact?source=${currentFormConfig.source}`,
            onSuccess: () => setShowFormModal(false),
            successMessage: currentFormConfig.successMessage,
          }}
          styleOverrides={{
            form: 'mt-16 gap-2',
            formField: 'rounded-none outline-[0.5px] bg-transparent outline-[#FFFFFF] placeholder:text-white',
            hideLabel: true,
            CTA: { alignment: 'w-full md:w-fit self-center mt-6 bg-[#FFFFFF] text-[#000000]' },
            accentColor: 'xumoAltBerryLight',
            hoverColor: 'xumoAltBerryDark',
          }}
        />
      )}
    </>
  );
};
